import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Select, Button } from "antd";
import { DeleteOutlined, MenuOutlined } from "@ant-design/icons";

export function SortableItem({
  materie = {},
  materii,
  setMaterii,
  materiiRedux = [],
  profesori,
  index,
  id,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: id,
      disabled: false,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div style={{ ...style, paddingTop: "20px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {/* Drag handle and delete button row */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <MenuOutlined
            style={{ cursor: "grab" }}
            {...listeners}
            ref={setNodeRef}
            {...attributes}
          />
          <Button
            icon={<DeleteOutlined />}
            danger
            size="small"
            onClick={() => {
              setMaterii(materii.filter((_, i) => i !== index));
            }}
          />
        </div>

        {/* Subject and teacher selectors */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "10px",
            width: "100%",
          }}
        >
          <Select
            showSearch
            placeholder="Materie"
            optionFilterProp="children"
            value={materie.materie}
            style={{
              width: isMobile ? "100%" : "50%",
              minWidth: isMobile ? "auto" : "100px",
            }}
            getPopupContainer={() => document.body}
            dropdownMatchSelectWidth={false}
            dropdownStyle={{
              maxWidth: isMobile ? "250px" : "auto",
              width: isMobile ? "auto" : "auto",
            }}
            onChange={(value) => {
              let subjects = JSON.parse(JSON.stringify(materii));
              subjects[index].materie = value;
              setMaterii(subjects);
            }}
            filterOption={(input, option) => {
              const searchTerm = input
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
              const label = (option?.label || "")
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
              return label.includes(searchTerm);
            }}
            options={materiiRedux
              .filter((mat) => mat.orar !== true || mat.id === materie.materie) // Exclude materiile cu orar: true DACĂ nu e materia selectată
              .map((mat) => ({
                label: mat.numeMaterie + "-" + mat.profil,
                value: mat.id,
              }))}
          />
          <Select
            mode="multiple"
            showSearch
            placeholder="Profesor"
            value={materie.profesori}
            style={{
              width: isMobile ? "100%" : "50%",
              minWidth: isMobile ? "auto" : "200px",
            }}
            getPopupContainer={() => document.body}
            dropdownMatchSelectWidth={false}
            dropdownStyle={{
              maxWidth: isMobile ? "250px" : "auto",
              width: isMobile ? "auto" : "auto",
            }}
            onChange={(value) => {
              let subjects = JSON.parse(JSON.stringify(materii));
              subjects[index].profesori = value;
              setMaterii(subjects);
            }}
            filterOption={(input, option) => {
              const searchTerm = input
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
              const label = (option?.label || "")
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
              return label.includes(searchTerm);
            }}
            options={profesori.map((prof) => {
              return {
                label: prof?.numeDeFamilie + "-" + prof?.prenume,
                value: prof?.id,
              };
            })}
          />
        </div>
      </div>
    </div>
  );
}
